import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http'
// import 'rxjs/Rx';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientUserMappingService {

  constructor(private http: HttpClient) { }

  getUserMappingInfo() {
    return this.http.get(environment.ApiUrl + '/api/ClientUserMappingManagement').pipe(map(res=>res));
  }

}
